angular.module('jv.requisition.details.controller', [])
    .controller('ReqsDetailsCtrl', ['$scope', 'Reqs', '$filter' , '$location', 'hireCustomer', 'ApplyFormPreviewService',
function ($scope, Reqs, $filter, $location, hireCustomer, ApplyFormPreviewService) {
    $scope.properties = angular.copy(window.properties);
    
    $scope.flags.loading = true;
    $scope.deleteModal = {};
    $scope.deleteModal.show = false;
    $scope.showErrorMsg = false;
    $scope.requisitions.postOpts = {};
    $scope.hireCustomer = hireCustomer;
    
    $scope.hasConfidentialRequisitionsEnabled = $scope.properties.hasConfidentialRequisitionsEnabled;
    $scope.hasLimitedJobPostingEnabled = $scope.properties.hasLimitedJobPostingEnabled;
    
    // Limited Access Requisitions enabling check
    $scope.isLimitedJobAccessPostingAllowed = ($scope.hasConfidentialRequisitionsEnabled && $scope.hasLimitedJobPostingEnabled);
    
    var options = angular.extend({ fields: true, paginated: $scope.flags.paginated }, $scope.params), urlParams = $scope.urlParams();
    if($location.search().hasOwnProperty('readMode')){
        options.readMode = $location.search().readMode;
    }else if(urlParams.hasOwnProperty('readMode')){
        options.readMode = urlParams.readMode;
    }

    if($scope.activeTab('#/details') && !$scope.activeTab('#/details-edit')){
        Reqs.details(options, function(requisitions){
            if (requisitions.forumBaseUrl) {
                $scope.$root.forumBaseUrl = requisitions.forumBaseUrl;
            }
            angular.extend($scope.requisitions, requisitions);
            var job= $scope.requisitions.jobDetails;
            /*show JobLink field only if REQ is in OPEN state and not private*/
            var jobState = $scope.requisitions.jobDetails.state;
            if(jobState !== 1 || (!((job.availableTo && !job.private) || (!job.availableTo && job.private)))) {
                angular.forEach($scope.requisitions.viewFields, function(vField,index){
                    if(vField.fieldId === -47){
                        $scope.requisitions.viewFields.splice(index,1);
                    }
                });
            }
            $scope.showIntegrationOptions = angular.isDefined(requisitions.integrations) && requisitions.integrations.length > 0;
            if($scope.showIntegrationOptions) {
                angular.forEach(requisitions.integrations, function(integration) {
                    integration.entityStatusValue = integration.entityStatus === 'ENABLED';
                });
            }
            // UT: Check for header(null and if already rendered) before rendering
            if(requisitions.tabIndex !== 1){
                $scope.routeRequest($scope.params, requisitions.tabIndex);
            }
            //  Above condition should ideally never happen, confirm with BE and remove it.
            if($scope.flags.paginated){
                $scope.flags.paginated = false;
            }
            $scope.params.id = $scope.requisitions.jobDetails.EId;
            $scope.flags.loading  = false;
            //Fetch the notes count only if the notes tab is visible
            if($scope.requisitions.views.notesTab){
                Reqs.getNotesCount($scope.params.id  ,function(response){
                    $scope.$parent.requisitions.notesCount = response.notesCount;
                });
            }
            if(requisitions.msgInfo){
                $scope.showMsg(requisitions.msgInfo);
            }
            // Call to get linkedIn sync Status for JOB
            $scope.linkedInSyncStatus();
        });
        if(options.id){
            Reqs.getPaginationCount(options,function(response){
                $scope.params.index = response.i;
                $scope.params.count = response.c;
                if(response.c === 0){
                    $scope.params.index = 1;
                    $scope.params.count = 1;
                }
                if(response.c < response.i){
                    $scope.params.index = $scope.params.count;
                }
            });
        }
    }

    // Filters values that are not user presentable
    var sanitize = function(field, type){
        // '0' is what BE stores as default values for these fields, so FE is supposed to sanitize it into a user presentable value(duh!).
        // Quickfix - #9389
        if(type === 'MultiLineText'  && (!field.hasOwnProperty('value') || field.value === '0') ){
            field.value = '--';
        }
    };

    $scope.type = function(field){
        var type = field.fieldType || field.objectType;
        if(!type){
            return 'NullField';
        }
        if ($.inArray(field.name, Reqs.postOptions) > -1) {
            type = 'NullField';
        }else if (field.fieldType === 'Text') {
            type= 'MultiLineText';
        } else if (type === 'CheckBox') {
            type = 'MultiSelect';
        } else if (type === 'Employee') {
            type = 'EmployeeNoDefault';
        }

        sanitize(field, type);

        return type;
    };

    $scope.previewApplyForm = function (formId, formName) {
        $scope.applyFormName = formName;
        $scope.applyFormFields = null;
        $scope.modals = {
            applyFormPreview: true
        };
        ApplyFormPreviewService.getForm(formId).then(function(fields) {
            $scope.applyFormFields = fields;
        });
    };

    $scope.isPostOptions = function (field) {
        return /-22|-18|-19|-46/g.test(field.fieldId);
    };
    
    $scope.showLinkedInSyncErrorIcon = false;
    $scope.linkedInSyncStatus = function() {
        Reqs.getLinkedInJobSyncStatus($scope.requisitions.jobDetails.EId  ,function(response) {
            if(response) {
                angular.forEach(response, function(syncDetails) {
                    if(syncDetails && syncDetails.syncStatus && syncDetails.type === 'LINKEDIN_ONE_CLICK_EXPORT') {
                        $scope.oneClickExportLastSyncDate = syncDetails.syncStatus.syncedOn;
                        $scope.showLinkedInSyncErrorIcon = !syncDetails.syncStatus.success;
                    }
                });
            }
        });
    };
    $scope.refreshLinkedInSync = function() {
        Reqs.syncjobToLinkedIn($scope.requisitions.jobDetails.EId  ,function(response) {
            if(response) {
                angular.forEach(response, function(syncDetails) {
                    if(syncDetails && syncDetails.syncStatus && syncDetails.type === 'LINKEDIN_ONE_CLICK_EXPORT') {
                        $scope.oneClickExportLastSyncDate = syncDetails.syncStatus.syncedOn;
                        $scope.showLinkedInSyncErrorIcon = !syncDetails.syncStatus.success;
                    }
                });
            }
        });
    };

}
]);
